import { gql } from "@apollo/client";

export const SEND_QUOTE = gql`
  mutation sendQuote($id: String!, $additionalMails: [String]) {
    sendQuote(id: $id, additionalMails: $additionalMails)
  }
`;

export const SEND_BOOKING_CONFIRMATION_EMAIL = gql`
  mutation sendConfirmBookingEmail($bookingId: String!,$additionalMails: [String]) {
    sendConfirmBookingEmail(bookingId: $bookingId,additionalMails: $additionalMails)
  }
`;

export const SEND_BOOKING_INFO_TO_HUBSPOT = gql`
  mutation syncDataOnHubspot($organisationId: String!,$bookingRefNumbers: [String]!) {
    syncDataOnHubspot(organisationId: $organisationId, bookingRefNumbers: $bookingRefNumbers){
        success
        message
    }
  }
`;